import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { ClientSettingImpl } from "../model/impl/ClientSettingImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class ClientSettingImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: ClientSettingImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.clientCd != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(1),
        false,
        encodable.clientCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.comment1 != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(2),
        false,
        encodable.comment1,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.comment2 != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(3),
        false,
        encodable.comment2,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.contactNameTxt != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(4),
        false,
        encodable.contactNameTxt,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.deskTxt != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(5),
        false,
        encodable.deskTxt,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.emailTxt != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(6),
        false,
        encodable.emailTxt,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.id != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(7),
        false,
        encodable.id,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.mobileTxt != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(8),
        false,
        encodable.mobileTxt,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.notifyEntry != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(9),
        false,
        encodable.notifyEntry,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.notifyExpiry != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(10),
        false,
        encodable.notifyExpiry,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.notifyFill != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(11),
        false,
        encodable.notifyFill,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.smsTxt != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(12),
        false,
        encodable.smsTxt,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.stamp != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(13),
        false,
        encodable.stamp,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.isDefaultFg != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(14),
        false,
        encodable.isDefaultFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.isDeletedFg != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(15),
        false,
        encodable.isDeletedFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientSettingImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,ClientSettingImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.lang.String"],
    [3, "java.lang.String"],
    [4, "java.lang.String"],
    [5, "java.lang.String"],
    [6, "java.lang.String"],
    [7, "java.lang.Long"],
    [8, "java.lang.String"],
    [9, "com.bcdfx.model.NotificationMethod"],
    [10, "com.bcdfx.model.NotificationMethod"],
    [11, "com.bcdfx.model.NotificationMethod"],
    [12, "java.lang.String"],
    [13, "java.lang.Long"],
    [14, "java.lang.Boolean"],
    [15, "java.lang.Boolean"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: ClientSettingImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.clientCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.comment1 = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.comment2 = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.contactNameTxt = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.deskTxt = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.emailTxt = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.id = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.mobileTxt = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: CubiqTS.NotificationMethod = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.notifyEntry = <CubiqTS.NotificationMethod>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: CubiqTS.NotificationMethod = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.notifyExpiry = <CubiqTS.NotificationMethod>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: CubiqTS.NotificationMethod = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.notifyFill = <CubiqTS.NotificationMethod>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.smsTxt = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.stamp = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.isDefaultFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.isDeletedFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientSettingImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,ClientSettingImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return ClientSettingImplEncoder.fidTypeMap.has(fid);
  }
}
